import React from "react";
import { Layout, theme } from "antd";
import styles from "./styles/QurealSection.module.css";

const { Content } = Layout;
const { useToken } = theme;

function QurealSection({
    header,
    children,
    header_sticky = true,
    footer = true,
    wrapper_style = {},
}) {
    const { token } = useToken();

    return (
        <div
            className={styles.wrapper}
            style={{ backgroundColor: token.colorBgLayout, ...wrapper_style }}
        >
            <Content
                className={styles.content}
                style={{ backgroundColor: token.colorBgContainer }}
            >
                <div
                    style={{
                        position: header_sticky ? "sticky" : "inherit",
                    }}
                    className={styles.header_wrapper}
                >
                    {header}
                </div>
                {children}
            </Content>
            {/* {footer && (
                <p
                    style={{
                        textAlign: "center",
                        color: token.colorTextDescription,
                    }}
                >
                    Made with ❤️ in India 🇮🇳
                </p>
            )} */}
        </div>
    );
}

export default QurealSection;
